export default __webpack_public_path__ + "53c88afb9a4b295b85dbfe46a6a196db.png";